<template>
  <div>
    <v-card>
      <v-card-subtitle>
        <v-icon x-large color="success"> mdi-check-circle </v-icon>
      </v-card-subtitle>
      <v-card-title>¡Pago exitoso!</v-card-title>
      <v-card-text>El pago ha sido completado con éxito para su número orden N°12345678</v-card-text>
    </v-card>

    <v-card style="margin-top: 20%">
      <v-card-subtitle>
        <v-icon x-large color="error"> mdi-close-circle </v-icon>
      </v-card-subtitle>
      <v-card-title>¡Pago rechazado!</v-card-title>
      <v-card-text>El pago ha sido rechazado, pruebe intentando de nuevo o con otro medio de pago</v-card-text>
      <v-card-actions>
        <v-btn>
          <v-icon left> mdi-pencil </v-icon>
          Seleccionar otra forma de pago
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'PaymeComponent'
}
</script>

<style scoped>
.v-card {
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  align-content: center;
  justify-content: space-evenly;
  height: 146px;
  width: 60%;
  margin-left: 20%;
  margin-top: 10%;
  background: #ffffff;
}

.v-card__title {
  display: flex;
  justify-content: center;
  padding: 0px;
}

.v-card__subtitle {
  display: flex;
  justify-content: center;
  padding: 0px;
}

.v-card__text {
  display: flex;
  justify-content: center;
}

.v-sheet.v-card:not(.v-sheet--outlined) {
  box-shadow:
    0px 0px 0px 0px rgb(0 0 0 / 0%),
    0px 0px 0px 0px rgb(0 0 0 / 0%),
    0px 0px 0px 0px rgb(0 0 0 / 0%);
}
</style>
